import { type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';

const messages = defineMessages({
  alternativeQuery: {
    defaultMessage:
      'Für deinen ursprünglichen <formatstrong>Suchbegriff "{query}"</formatstrong> haben wir leider <formatstrong>kein Suchergebnis</formatstrong> gefunden. Lasse dich von diesen <formatstrong>{count} alternativen Vorschlägen</formatstrong> inspirieren.',
    description: 'deep query hint message',
    id: 'deepQueryHint.alternativeQuery',
  },
});

export type DeepQueryHintProps = {
  /** the number of search results */
  count: number;
  /** the original search query */
  query: string;
};

/**
 * DeepQueryHint component description displayed in storybook
 * */
export const DeepQueryHint = ({ query, count }: DeepQueryHintProps) => {
  const { formatMessage } = useIntl();

  return (
    <Notification variant="outline" severity="info">
      <h1 className="text-size-body-sm text-center">
        {formatMessage(messages.alternativeQuery, {
          count,
          formatstrong: (chunks: ReactNode) => (
            <span className="text-size-body-sm font-bold">{chunks}</span>
          ),
          query,
        })}
      </h1>
    </Notification>
  );
};
